import React from 'react';
import { ImageTitleContent } from '@axa-asia/emma-stylesheet';
import { useSelector } from 'react-redux';
import { getTrackerConnectSuccessInfo } from '../../selectors/aktivoOnboardingSelectors';
import { getLanguage } from '../../../healthkeeper/selectors/configSelectors';
import { isApp, resolveLargeImage } from '../../../../utils';
import './style.scss';
import { EmmaFactory } from '@axa-asia/hk-emma-js';
import { goto } from '../../../../actions/historyActions';
import { showBackButton } from '../../../../utils/AppUtils';

const ConnectDevicesSuccess = () => {
  const config = useSelector(getTrackerConnectSuccessInfo);
  const language = useSelector(getLanguage);
  const openDeeplink = (deeplink: string) => {
    showBackButton();
    goto(deeplink);
  };
  return (
    <div className="connect-devices-success__container">
      <div className="connect-devices-success__header-container">
        {config.image && (
          <div
            className="connect-devices-success__header-container__image"
            style={{
              backgroundImage: `url(${
                config.image && resolveLargeImage(config.image)
              })`,
            }}
          />
        )}
        {config.title && (
          <div className="connect-devices-success__header-container__title">
            {config.title[language]}
          </div>
        )}
        {config.description && (
          <div className="connect-devices-success__header-container__description">
            {config.description[language]}
          </div>
        )}
        <div className="connect-devices-success__header-container__divider" />
      </div>
      <div className="connect-devices-success__topic-card__item">
        {config.topicCard.map((topicCard: any, topicCardIndex: number) => (
          <div
            key={topicCardIndex.toString()}
            className="connect-devices-success__topic-card__item__container"
          >
            <div
              className="connect-devices-success__topic-card__item__image"
              style={{
                backgroundImage: `url(${
                  !!topicCard &&
                  !!topicCard.image &&
                  resolveLargeImage(topicCard.image)
                })`,
              }}
            />
            <div className="connect-devices-success__topic-card__item__title">
              {topicCard && topicCard.title[language]}
            </div>
          </div>
        ))}
      </div>
      {config.remarks && (
        <div className="connect-devices-success__remarks">
          {config.remarks[language]}
        </div>
      )}
      {(config.buttonOneText || config.buttonTwoText) && (
        <div className="connect-devices-success__buttons__container">
          {config.buttonOneText && (
            <button
              className="emma-stylesheet-primary-default-button"
              onClick={() => openDeeplink(config.buttonOneDeeplink)}
              data-enable-ga
              data-ga-type="button"
            >
              {config.buttonOneText[language]}
            </button>
          )}
          {config.buttonOneText && config.buttonTwoText && (
            <div style={{ marginTop: 8 }} />
          )}
          {config.buttonTwoText && (
            <button
              className="emma-stylesheet-primary-ghost-button"
              onClick={() => openDeeplink(config.buttonTwoDeeplink)}
              data-enable-ga
              data-ga-type="button"
            >
              {config.buttonTwoText[language]}
            </button>
          )}
        </div>
      )}
    </div>
  );
  // !!config && rulesConfig.cards.map(card: any, index: number) => {
  //       return (<div className="connect-devices-success__container">
  //                 <div className="connect-devices-success__topic-card__title">
  //                 {card.topicCard.title[language]}
  //               </div>
  //               <div className="connect-devices-success__topic-card__item">
  //               {card.topicCard.items.map(
  //                   (topicCard: any, topicCardIndex: number) => (
  //                     <div
  //                       key={topicCardIndex.toString()}
  //                       className="connect-devices-success__topic-card__item__container"
  //                     >
  //                       <div className="my-wellness-rules__topic-card__item__image" style={{ backgroundImage: `url(${!!topicCard && !!topicCard.image && resolveLargeImage(topicCard.image)})`, }} />
  //                       <div className="connect-devices-success__topic-card__item__title">{topicCard && topicCard.title[language]}</div>
  //                     </div>
  //                   )
  //                 )}
  //                 </div>
  //             </div>
};

export default ConnectDevicesSuccess;
